import {Base} from "@/api/Base"

export class OvertimeApplicationApprove extends Base {
    path = "overtimeApplication/approve"
}